<template>
    <v-dialog
    v-model="show"
    persistent
    width="850">
   
    <v-card>
            <v-toolbar class="ma-1"  dense  elevation="0" rounded>
            <v-icon left >mdi-clipboard-text-clock</v-icon><span class="va-underline">Transaction History</span>
            <v-spacer/>
            <v-btn  @click="emitToParent('close')" fab x-small elevation="1" color="warning"><v-icon >mdi-close</v-icon></v-btn>
          </v-toolbar>
            <v-divider class="ma-2"/>
          <v-card-text>
            <p class="text-center">
            <v-avatar size="60" >
                                              <img v-if="customer.files.profile_picture!=''" :src="customer.files.profile_picture">
                                              <img v-else :src="$store.state.imgholder" />
                                            </v-avatar>
                                            <br/>

                 Name: {{fullname}} 
               </p>  
                 <p class="text-center">
                 <v-icon small left>mdi-email</v-icon> {{customer.contact.email}}
                           |
                            <v-icon small left>mdi-cellphone-basic</v-icon> {{customer.contact.mobile}}
                             |
                              <v-icon small left>mdi-phone-classic</v-icon> {{customer.contact.telephone}}
                  </p>            
                     
                <v-divider class="mt-2"/>
                 <table class="va-table va-table-border-bot">
                     <tr>
                      
                         <th>Trans. Date</th>
                        <th>Type</th>
                        <th>Transaction No.</th>
                        <th>Trans. Date</th>
                        <th>Payment</th>
                        <th class="text-right">Amount</th>
                     </tr> 
                     <tr v-for="(item, index) in items" :key="index">
                        <td>{{ $moment(item.created_at).format("YYYY-MM-DD") }}</td>
                        <td>{{ item.type }}</td>
                        <td>{{ item.id }}</td>
                        <td :class="STATUS_BG(item.status)" class="text-center text-white">{{ item.payment_status }}</td>
                        <td :class="STATUS_BG(item.status)" class="text-center text-white">{{ item.status }}</td>
                        <td class="text-right">{{ $money(item.total_amount) }}</td>
                     </tr>
                </table>  
          </v-card-text>
          <v-card-actions>
              <v-btn small color="error" text @click="emitToParent('close')">
                 Close
              </v-btn>
              <v-spacer/>
              
          </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
      show:{
          type: Boolean,
          default: false
      },
      customer: {
            type: Object,
          default:()=>{}
      },
    
  },
    data: () => ({
        fullaname: "",
        items:[]
    }),
   watch: {
    show (v) {
        if(v) {
            this.fullname = this.setfullname(this.customer.profile)
            this.getItems()
        }
        
    }
   }, 
  methods: {
   emitToParent (action) {
      this.$emit('ConfirmEvent', action)
    },
    setfullname(profile){
          if(profile.lastname == "") {
            return profile.firstname
          }
        
          return profile.lastname +', '+ profile.firstname
        },
    getItems() { 
        this.VA_ALERT('info', 'Loading customer history', 'progress', 100, 1500)
        this.items = []
        this.QUERY('vendors',`select * from sales where customer_id=${this.customer.id} order by id desc`, (res)=>{
            console.log(res)
            if(res.status) {
                this.items = res.results
            }
            
        })
    }   
  }
}
</script>
